'use strict';

const Enum = require('./enum');

/**
 * Whether the Door Position Sensor uses a magnetometer or accelerometer to determine the door state.
 */
exports.DoorPositionSensorModes = Object.create(Enum, {
  DISABLED: { value: 'disabled', enumerable: true },
  MAGNET: { value: 'magnet', enumerable: true },
  TILT: { value: 'tilt', enumerable: true },
});

exports.DoorPositionSensorBatteryLevels = Object.create(Enum, {
  MAX: { value: 100, enumerable: true },
  MIN: { value: 0, enumerable: true },
});

exports.DoorPositionSensorBatteryPercentages = Object.create(Enum, {
  VERY_LOW: { value: 50, enumerable: true },
  LOW: { value: 55, enumerable: true },
  MEDIUM: { value: 70, enumerable: true },
  FULL: { value: 100, enumerable: true },
  toTranslationKey: {
    value: function(percentage) {
      switch (true) {
        case percentage < exports.DoorPositionSensorBatteryLevels.MIN:
          return 'doorPositionSensorBatteryPercentageUnknown';
        case percentage <= this.VERY_LOW:
          return 'doorPositionSensorBatteryPercentageVeryLow';
        case percentage <= this.LOW:
          return 'doorPositionSensorBatteryPercentageLow';
        case percentage <= this.MEDIUM:
          return 'doorPositionSensorBatteryPercentageMedium';
        case percentage <= this.FULL:
          return 'doorPositionSensorBatteryPercentageFull';
        default:
          return 'doorPositionSensorBatteryPercentageUnknown';
      }
    },
    enumerable: false,
  },
  toEnum: {
    value: function(percentage) {
      switch (true) {
        case percentage <= this.VERY_LOW:
          return this.VERY_LOW;
        case percentage <= this.LOW:
          return this.LOW;
        case percentage <= this.MEDIUM:
          return this.MEDIUM;
        case percentage <= this.FULL:
          return this.FULL;
        default:
          return undefined;
      }
    },
    enumerable: false,
  },
});

exports.DPS_LOG_ATTRS = {
  type: 'log_type',
  time: 'timeStamp',
  batteryLevelPercent: 'batteryLevelPercent',
};
